import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Grid,
  // TextField,
  Tooltip,
  Button,
  createTheme,
  ThemeProvider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import ResponsiveIconButton from "../../../../Forms/ResponsiveIconButton";
import AutoCompleteField from "../../../../Forms/AutoCompleteField";
import MapIcon from "@mui/icons-material/Map";
import MapCenterInput from "./MapCenterInput";
import ResponsiveButton from "../../../../Forms/ResponsiveButton";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import DeviceInfoPanel from "./DeviceInfoPanel";
import WeekStartSetting from "./WeekStartSetting";
import { newReportsEnabled } from "../../../../../utils/features";

const fontSx = {
  fontSize: ["1rem", "1rem", "1rem", "1rem", "1.5rem", "1.5rem"],
};

const buttonStyles = {
  autofillButton: {
    color: "status.info",
    borderColor: "status.info",
  },
  infoButton: {
    color: "status.info",
  },
};

// const numberInputSx = {
//   "& .MuiOutlinedInput-input": {
//     fontSize: ["1rem", "1rem", "1rem", "1rem", "1.5rem", "1.5rem"],
//     py: ["0.25rem", "0.25rem", "0.25rem", "0.25rem", "0.5rem", "0.5rem"],
//   },
// };

const theme = createTheme({
  components: {
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          // '&.Mui-collapsed': {
          //     minHeight: '55px', // Adjust minHeight when collapsed
          // },
          "&.Mui-expanded": {
            minHeight: "55px", // Adjust minHeight when expanded
          },
        },
      },
    },
  },
});

const Settings = ({
  email,
  name,
  setAutofillModalOpen,
  setAlgorithmSettingModalOpen,
  organizationDisplayName,
  mapCenter,
  timeZoneOptions,
  timeZone,
  updateUserTimeZoneSettings,
  addressSearchRadius,
  // updateUserAddressSearchRadiusSettings,
  updateUserMapCenterSettings,
  mapCenterPlacementMode,
  setMapCenterPlacementMode,
  saveUserSetting,
}) => {
  const [value, setValue] = useState({
    value: "AUTO",
    abbr: "",
    offset: 0,
    isdst: false,
    text: "Auto Detect",
    utc: [""],
  });
  const [inputValue, setInputValue] = useState("");

  const handleSave = () => {
    saveUserSetting(timeZone.value, mapCenter, addressSearchRadius);
  };

  const [userInfoOpen, setUserInfoOpen] = useState(true);
  const [deviceInfoOpen, setDeviceInfoOpen] = useState(true);
  const [orgInfoOpen, setOrgInfoOpen] = useState(true);

  useEffect(() => {
    setValue(timeZone);
  }, [timeZone]);
  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      {/* User Info Accordion */}
      <ThemeProvider theme={theme}>
        <Accordion
          expanded={userInfoOpen}
          onChange={() => setUserInfoOpen(!userInfoOpen)}
          slotProps={{ heading: { component: 'h4' } }}
        >
          <AccordionSummary
            expandIcon={
              userInfoOpen ? (
                <ArrowDropUpIcon className="text-white" />
              ) : (
                <ArrowDropDownIcon className="text-white" />
              )
            }
            sx={{
              backgroundColor: "#167bc3",
              border: "2px solid white",
              minHeight: 50,
              height: 50,
            }}
            className={"text-white"}
          >
            <Typography>User Info</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container rowSpacing={2} columnSpacing={1}>
              <Grid size={4} >
                <Typography sx={fontSx} className={"text-gray-600"}>
                  Name:
                </Typography>
              </Grid>
              <Grid size={8}>
                <Typography sx={fontSx}>{name}</Typography>
              </Grid>

              <Grid size={4}>
                <Typography sx={fontSx} className={"text-gray-600"}>
                  Email:
                </Typography>
              </Grid>
              <Grid size={8}>
                <Typography sx={fontSx}>{email}</Typography>
              </Grid>

              <Grid size={4}>
                <Typography sx={fontSx} className={"text-gray-600"}>
                  Organization:
                </Typography>
              </Grid>
              <Grid size={8}>
                <Typography sx={fontSx}>{organizationDisplayName}</Typography>
              </Grid>

              <Grid size={4}>
                <Typography sx={fontSx} className={"text-gray-600"}>
                  Time Zone:
                </Typography>
              </Grid>
              <Grid size={8}>
                <AutoCompleteField
                  noLabel={true}
                  value={value}
                  onChange={(event, newValue) => {
                    updateUserTimeZoneSettings(newValue?.value);
                    setValue(newValue);
                  }}
                  inputValue={inputValue}
                  onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);
                  }}
                  getOptionLabel={(option) => option.abbr + " " + option.text}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value?.value
                  }
                  options={timeZoneOptions}
                />
              </Grid>
              <Grid size={4}>
                <Typography sx={fontSx} className={"text-gray-600"}>
                  Map Center:
                </Typography>
              </Grid>
              <Grid size={8}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ flexBasis: "80%" }}>
                    <MapCenterInput
                      mapCenter={mapCenter}
                      updateUserMapCenterSettings={
                        updateUserMapCenterSettings
                      }
                    />
                  </Box>

                  <Box sx={{ flexBasis: "20%" }}>
                    <Tooltip
                      title={
                        <Typography variant="subtitle1">
                          Click to enable map center placement mode on map
                        </Typography>
                      }
                    >
                      <Button onClick={() => setMapCenterPlacementMode(true)}>
                        <MapIcon
                          color={
                            mapCenterPlacementMode ? "disabled" : "primary"
                          }
                        />
                      </Button>
                    </Tooltip>
                  </Box>
                </Box>
              </Grid>

              {/* <Grid size={4}>
                <Typography sx={fontSx} className={"text-gray-600"}>
                  Address Search Radius:
                </Typography>
              </Grid>
              <Grid size={8}>
                <TextField
                  value={addressSearchRadius}
                  type="number"
                  inputProps={{ step: 10 }}
                  sx={numberInputSx}
                  onChange={(event) => {
                    const value = parseInt(event.target.value, 0);
                    updateUserAddressSearchRadiusSettings(value);
                  }}
                  onBlur={(event) => {
                    if (
                      event.target.value === "" ||
                      parseInt(event.target.value) <= 0
                    ) {
                      updateUserAddressSearchRadiusSettings(100); // Default to 100 if invalid value
                    }
                  }}
                />
              </Grid> */}
              <Grid size={4}>
                <Typography sx={fontSx} className={"text-gray-600"}>
                  Specimen Autofill:
                </Typography>
              </Grid>
              <Grid size={8}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <ResponsiveIconButton
                    onClick={() => setAutofillModalOpen(true)}
                  >
                    <SettingsIcon sx={buttonStyles.infoButton} />
                  </ResponsiveIconButton>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  mt: "10px",
                }}
              >
                <ResponsiveButton
                  variant="contained"
                  style={{
                    color: "#2196F3",
                    backgroundColor: "white",
                    borderColor: "rgba(63, 81, 181, 0.5)",
                    border: "1px solid",
                    boxShadow: "none",
                  }}
                  onClick={handleSave}
                >
                  SAVE
                </ResponsiveButton>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </ThemeProvider>
      {/* Device Info Accordion */}
      <ThemeProvider theme={theme}>
        <Accordion
          expanded={deviceInfoOpen}
          onChange={() => setDeviceInfoOpen(!deviceInfoOpen)}
        >
          <AccordionSummary
            expandIcon={
              deviceInfoOpen ? (
                <ArrowDropUpIcon className="text-white" />
              ) : (
                <ArrowDropDownIcon className="text-white" />
              )
            }
            sx={{
              backgroundColor: "#167bc3",
              border: "2px solid white",
              minHeight: 50,
              height: 50,
            }}
            className={"text-white"}
          >
            <Typography>Device Info</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <DeviceInfoPanel />
          </AccordionDetails>
        </Accordion>
      </ThemeProvider>

      {/* Organization Info Accordion */}
      <ThemeProvider theme={theme}>
        <Accordion
          expanded={orgInfoOpen}
          onChange={() => setOrgInfoOpen(!orgInfoOpen)}
          sx={{ width: "100%" }}
        >
          <AccordionSummary
            expandIcon={
              orgInfoOpen ? (
                <ArrowDropUpIcon className="text-white" />
              ) : (
                <ArrowDropDownIcon className="text-white" />
              )
            }
            sx={{
              backgroundColor: "#167bc3",
              border: "2px solid white",
              minHeight: 50,
              height: 50,
            }}
            className={"text-white"}
          >
            <Typography>Organization Info</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container rowSpacing={2} columnSpacing={1}>
              <Grid size={4}>
                <Typography sx={fontSx} className={"text-gray-600"}>
                  Organization:
                </Typography>
              </Grid>
              <Grid size={8}>
                <Typography sx={fontSx}>{organizationDisplayName}</Typography>
              </Grid>

              {newReportsEnabled() && (
                <>
                  <Grid size={4}>
                    <Typography sx={fontSx} className={"text-gray-600"}>
                      Weeks start on:
                    </Typography>
                  </Grid>
                  <Grid size={8} sx={{ display: "flex", justifyContent: "center" }}>
                    <WeekStartSetting />
                  </Grid>
                </>
              )}

              <Grid size={4}>
                <Typography sx={fontSx} className={"text-gray-600"}>
                  Algorithm Setting:
                </Typography>
              </Grid>
              <Grid size={8}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <ResponsiveIconButton
                    onClick={() => setAlgorithmSettingModalOpen(true)}
                  >
                    <SettingsIcon sx={buttonStyles.infoButton} />
                  </ResponsiveIconButton>
                </Box>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </ThemeProvider>
    </Box>
  );
};

export default Settings;
